"use strict";
function abortable(handle, signal) {
  const controller = new AbortController();
  const removeEventListener = addEventListener(controller.signal, "abort", () => {
    removeEventListener();
    const handles = Array.isArray(handle) ? handle : [handle];
    handles.forEach((handle2) => typeof handle2 === "function" ? handle2() : handle2 instanceof AbortController ? handle2.abort() : clearTimeout(handle2));
    handles.length = 0;
  });
  if (signal !== void 0) {
    chainAbort(signal, controller);
  }
  return controller;
}
function chainAbort(signal, controller) {
  if (signal.aborted) {
    controller.abort();
    return;
  }
  const removeSignalListener = addEventListener(signal, "abort", () => {
    controller.abort();
  });
  const removeControllerListener = addEventListener(controller.signal, "abort", () => {
    removeControllerListener();
    removeSignalListener();
  });
}
function addEventListener(target, type, listener, options) {
  target.addEventListener(type, listener, options);
  return () => target.removeEventListener(type, listener, options);
}
export {
  abortable,
  addEventListener,
  chainAbort
};
